import { useContext, useState, useEffect } from 'react';

import Box from '@mui/material/Box';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

import LegacyRecordingsTable from './LegacyRecordingsTable';
import { ClassContext } from '../../context/ClassContext';
import { getUserUuidHeaders } from '../../utils/httpUtils';
import { getUrls } from '../../utils/url';
import MainLayout from '../layout/MainLayout';

export const LegacyRecordingsWrapper = () => {
    const classContext = useContext(ClassContext);
    const [isLoading, setIsLoading] = useState(false);
    const [recordings, setRecordings] = useState<any>(undefined);
    const { t } = useTranslation();

    const {
        userUuid,
        classData: {
            class: { class_name: className, meeting_id: meetingId }
        }
    } = classContext;

    useEffect(() => {
        const fetchLegacyRecordings = async () => {
            const { api } = getUrls();

            if (!meetingId) {
                return;
            }
            try {
                setIsLoading(true);
                const config = {
                    headers: getUserUuidHeaders(userUuid)
                };
                const { data } = await axios.get(`${api}/meeting/${meetingId}/get_legacy_recordings`, config);
                setIsLoading(false);
                setRecordings(data);
            } catch (e) {
                // This is a legacy view that will be going away soon and so a plain old untranslated alert message
                // on failure will do.
                setIsLoading(false);
                setRecordings(undefined);
            }
        };
        fetchLegacyRecordings();
    }, [userUuid, meetingId]);

    return (
        <MainLayout title={t('lti:recordings.forclass', { name: className })}>
            <Box sx={{ py: '28px', px: '40px' }}>
                <LegacyRecordingsTable {...{ recordings, isLoading }} />
            </Box>
        </MainLayout>
    );
};
